EBContext.modules.Loader = function(options){
	this.options = EBContext.utils.extendObj(false, {
		parentElement: null,
		loaderClass: 'fas fa-fw fa-spinner fa-spin',
		loaderType: 'overlay',
		prependLoader: false,
		disableParentElement: true,
		independent: false,
		loaderIcon: {
			icon: 'spinner',
			animation: 'spin'
		}
	}, options);
	if(!this.options.parentElement) return EBContext.ajaxNav.options.loader; //pou�ije se v�choz� ajaxNav loader
	
	this.loaderEl = document.createElement('i');
	this.loaderEl.className = this.options.loaderClass;
	this.ajaxQueue = (this.options.independent ? [] : EBContext.ajaxNav.ajaxQueue);
	
	this.getIcon = element=>{
		return {
			icon: element.getAttribute('data-icon'),
			element: element,
			animation: (el=>{
				for(const cl of [...el.classList]){
					if(cl==='fa-spin') return 'spin';
					if(cl==='fa-pulse') return 'pulse';
					return null;
				}
			})(element)
		};
	};
	this.setIcon = (element, icon)=>{
		element.setAttribute('data-icon', icon.icon);
		element.classList.remove('fa-spin','fa-pulse');
		if(icon.animation) element.classList.add('fa-'+icon.animation);
	};
	
	this.disableParentElement = function(disable){
		if(disable){
			this.origDisabled = this.options.parentElement.getAttribute('disabled');
			this.options.parentElement.setAttribute('disabled', 'disabled');
		} else{
			if(this.origDisabled === null){
				this.options.parentElement.removeAttribute('disabled');
			}
			else{
				this.options.parentElement.setAttribute('disabled', this.origDisabled);
			}
		}
	};
	this.init = function(options){
		EBContext.utils.extendObj(false, this.options, options);
		if(this.options.loaderType === 'overlay'){
			this.parentContainer = document.createElement('div');
			this.parentContainer.className = 'loader_parentContainer';
			this.parentContent = document.createElement('div');
			this.parentContent.className = 'loader_parentContent';
			this.loaderWrap = document.createElement('div');
			this.loaderWrap.className = 'loader_loaderWrap';
			this.loaderWrap.appendChild(this.loaderEl);
			
			this.enabled = true;
			this.fnLoaderStart = function () {
				while(this.options.parentElement.childNodes.length>0){
					this.parentContent.appendChild(this.options.parentElement.childNodes[0]);
				}				
				this.parentContainer.appendChild(this.parentContent);
				this.options.parentElement.appendChild(this.parentContainer);
				this.origVisibility = this.parentContent.style.visibility;
				if(this.options.disableParentElement){
					this.disableParentElement(true);
				}
				this.parentContent.style.visibility = 'hidden';
				this.parentContainer.appendChild(this.loaderWrap);
			};
			this.fnLoaderEnd = function () {
				if(this.options.disableParentElement){
					this.disableParentElement(false);
				}
				while(this.parentContent.childNodes.length>0){
					this.options.parentElement.appendChild(this.parentContent.childNodes[0]);
				}
				if(this.loaderWrap.parentElement) this.loaderWrap.parentElement.removeChild(this.loaderWrap);
				if(this.parentContainer.parentElement) this.parentContainer.parentElement.removeChild(this.parentContainer);
				// this.parentContent.style.visibility = this.origVisibility;
			};
		} else if(this.options.loaderType === 'append'){
			this.loaderItem = document.createElement('div');
			this.loaderItem.className = 'loader_loaderItem';
			this.loaderItem.appendChild(this.loaderEl);
			this.enabled = true;
			this.fnLoaderStart = function () {
				if(this.options.disableParentElement){
					this.disableParentElement(true);
				}
				if(this.options.prependLoader && this.options.parentElement.firstChild){
					this.options.parentElement.insertBefore(
						this.loaderItem, 
						this.options.parentElement.firstChild
					);
				}
				else{
					this.options.parentElement.appendChild(this.loaderItem);
				}
			};
			this.fnLoaderEnd = function () {
				if(this.options.disableParentElement){
					this.disableParentElement(false);
				}
				if(this.loaderEl.parentElement) this.loaderEl.parentElement.removeChild(this.loaderItem);
			};
		} else if(this.options.loaderType === 'replace'){
			this.enabled = true;
			this.fnLoaderStart = function () {
				if(this.options.disableParentElement){
					this.disableParentElement(true);
				}
				let iconEl = this.options.parentElement.querySelector('svg[data-icon]');
				this.origIcon = this.getIcon(iconEl);
				this.setIcon(iconEl, this.options.loaderIcon);
			};
			this.fnLoaderEnd = function () {
				if(this.options.disableParentElement){
					this.disableParentElement(false);
				}
				let iconEl = this.options.parentElement.querySelector('svg[data-icon]');
				this.setIcon(iconEl, this.origIcon);
			}
		} else{
			// this.parentIcon = this.options.parentElement.querySelector('svg[data-icon]');
		}
	};
	this.init();
	return this;
};
/* 
	P��klad pou�it�:
	var loaderObj = new EBContext.modules.Loader({
		parentElement: btn,
		loaderClass: 'fas fa-spinner fa-pulse',
		loaderType: 'overlay'
	});
	EBContext.ajaxNav.ajaxCall('/?ajax=1&action=BasketAddItems&ebPageItemUpdate=*basketBox,headerBasketProducts', null, 'goods=' + encodeURIComponent(goods), { loader: loaderObj });
*/